<template>
  <single-device
    :device="singleDevice"
    :on-form-submitted="formSubmitted"
    :loading="loadingDevices"
    :settings="settings" />
</template>

<script>
import SingleDevice from '@/components/devices/SingleDevice';
import * as actions from '@/store/actions.type';
import { DASHBOARD_URL } from '@/router/constants';
import { 
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from '@/common/event.types';
import {
  mapActions,
  mapGetters
} from 'vuex';

export default {
  name: 'CreateDevice',
  computed: {
    ...mapGetters([
      'singleDevice',
      'loadingDevices',
      'settings'
    ])
  },
  mounted () {
    if(!this.settings.defaultDeviceRefreshRate && !this.singleDevice.refreshRate) {
      this.fetchSettingsAction()
        .then(() => {
          this.updateDefaultRefreshRateAction(this.settings);
        })
    } else {
      this.updateDefaultRefreshRateAction(this.settings);
    }
  },
  destroyed() {
    this.resetSingleDeviceStateAction();
  },
  methods: {
    ...mapActions({
      createDeviceRequestAction: actions.CREATE_DEVICE,
      resetSingleDeviceStateAction: actions.RESET_SINGLE_DEVICE_STATE,
      fetchSettingsAction: actions.GET_CURRENT_SETTINGS,
      updateDefaultRefreshRateAction: actions.UPDATE_DEFAULT_DEVICE_REFRESH_RATE
    }),
    formSubmitted(newDevice) {
      this.createDeviceRequestAction(newDevice)
        .then(r => {
          this.$eventHub.$emit(NOTIFICATION_SUCCESS, {
            message: this.$t('device.notificatons.created')
          })
          this.$router.push(DASHBOARD_URL);
        })
        .catch(({ data }) => {
          this.$eventHub.$emit(NOTIFICATION_ERROR, {
            message: data
          })
        })
    }
  },
  components: {
    SingleDevice
  }
}
</script>